<template>
  <div class="w3-container  w3-light-grey" style="padding:64px 16px 128px 16px" id="contact">
    <h3 class="w3-center" style="margin-bottom: 48px;">{{ $t('contact.title') }}</h3>
    <p class="w3-center w3-large" style="margin-bottom: 5%;" v-html="$t('contact.description')"></p>
    <div class="w3-row-padding">
      <div class="w3-center w3-hide-small w3-hide-medium" >
        <div class="w3-col l4">
          <i class="fa fa-map-marker fa-fw w3-xxlarge w3-margin-right"></i> {{ $t('contact.address') }}
        </div>        
        <div class="w3-col l4">
          <i class="fa fa-envelope fa-fw w3-xxlarge w3-margin-right"></i> {{ $t('contact.email') }}@{{ $t('contact.emailDomain') }}
        </div>
        <div class="w3-col l4">
          <i class="fa fa-telegram fa-fw w3-xxlarge w3-margin-right"></i> @{{ $t('contact.telegram') }}
        </div>
      </div>
      <div class="w3-right w3-hide-large" >
        <div class="w3-col l4">
          <i class="fa fa-map-marker fa-fw w3-xxlarge w3-margin-right"></i> {{ $t('contact.address') }}
        </div>        
        <div class="w3-col l4">
          <i class="fa fa-envelope fa-fw w3-xxlarge w3-margin-right"></i> {{ $t('contact.email') }}@{{ $t('contact.emailDomain') }}
        </div>
        <div class="w3-col l4">
          <i class="fa fa-telegram fa-fw w3-xxlarge w3-margin-right"></i> @{{ $t('contact.telegram') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactSection',
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      loading: false,
      success: false,
      error: ''
    }
  },
  methods: {
    async submitForm() {
      this.loading = true
      this.error = ''
      this.success = false

      try {
        // Simulate API call to send email
        await this.sendEmail()

        this.success = true
        this.resetForm()

        // Hide success message after 5 seconds
        setTimeout(() => {
          this.success = false
        }, 5000)

      } catch (err) {
        this.error = this.$t('contact.error.network')
      } finally {
        this.loading = false
      }
    },

    async sendEmail() {
      // Simulate API call delay
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // In a real application, you would make an API call here
          // For example using axios to your backend endpoint
          console.log('Email sent to mock@mock.mock with data:', this.form)

          // Simulate random failure (10% chance)
          if (Math.random() < 0.1) {
            reject(new Error('Network error'))
          } else {
            resolve()
          }
        }, 1500)
      })
    },

    resetForm() {
      this.form = {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.w3-input {
  border: 1px solid #ccc !important;
  padding: 8px;
  display: block;
  border: none;
  width: 100%;
}

.w3-section {
  margin: 16px 0;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>